import { platformAPI } from '@/utils/api';
import {
  isTemuShopAuthorized,
  normalizeTemuShopType,
} from '@/temu-platform/constants/temuRoutes';

export const TEMU_SHOP_AUTH_EXPIRED_MESSAGE = '店铺授权已过期，请先在平台管理完成授权后再进入';

/**
 * 当前工作区已授权的 TEMU 店铺列表（走 platform API，门禁解锁前可用）。
 * @param {{ shopType?: string }} [options]
 */
export async function listAuthorizedTemuShops(options = {}) {
  const list = await platformAPI.listShops();
  const shops = Array.isArray(list) ? list : [];
  const filterType = normalizeTemuShopType(options.shopType);

  return shops.filter((shop) => {
    if (String(shop?.platformCode || '').toUpperCase() !== 'TEMU') return false;
    if (!isTemuShopAuthorized(shop)) return false;
    if (filterType && normalizeTemuShopType(shop?.shopType) !== filterType) return false;
    return true;
  });
}

/** 当前工作区是否存在已授权 TEMU 店铺。 */
export async function hasAuthorizedTemuShop(options = {}) {
  const shops = await listAuthorizedTemuShops(options);
  return shops.length > 0;
}
